// extracted by mini-css-extract-plugin
export default {"range":"wL0uwpAn3HIKxYawKUoL"};